import CenteredContentLayout from "@/components/layout/CenteredContentLayout";
import Header from "@/components/layout/Header";
import PageHeaderTitle from "@/components/layout/PageHeaderText";
import PageLayout from "@/components/layout/PageLayout";
import { createFileRoute } from "@tanstack/react-router";
import ReferralCopyButton from "./-components/ReferralCopyButton";
import ReferralEarnings from "./-components/ReferralEarnings";
import ReferralEarningsCard from "./-components/ReferralEarningsCard";
import ReferralImage from "./-components/ReferralImage";

export const Route = createFileRoute("/_main/referral/")({
  head: () => ({
    meta: [{ title: "Reactor | Referrals" }],
  }),
  component: ReferralPage,
});

function ReferralPage() {
  return (
    <PageLayout
      header={
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center gap-5">
            <PageHeaderTitle title="My Referrals" />
          </div>
          <Header />
        </div>
      }
    >
      <CenteredContentLayout>
        <div className="flex h-full w-full flex-col gap-1.5">
          <div className="flex h-full w-full flex-col gap-1.5 overflow-y-auto xl:flex-row xl:overflow-hidden">
            <div className="flex w-full flex-col gap-1.5 xl:w-[40%] 2xl:w-[642px]">
              <div className="min-h-[390px] w-full overflow-hidden rounded-3xl bg-card p-4 sm:p-4 md:p-5 xl:h-[calc(100%-300px)]">
                <div className="relative flex h-full items-center justify-center">
                  <div className="absolute inset-0 bg-[radial-gradient(#2A2A3B75_1.5px,transparent_1px)] [background-size:16px_16px]" />
                  <div className="relative z-20 h-full w-full">
                    <ReferralImage />
                  </div>
                </div>
              </div>
              <ReferralEarningsCard />
            </div>
            <div className="flex h-full flex-1 flex-col gap-5 rounded-3xl bg-card p-5">
              <ReferralCopyButton />
              <ReferralEarnings />
            </div>
          </div>
        </div>
      </CenteredContentLayout>
    </PageLayout>
  );
}
